export default __webpack_public_path__ + "static/media/second.15dcf680.jpg";